import React from 'react';
import './Banner.css'


const Banner = () => {
    return (
        <div className="banner-container">
            <div>
                <br /><br /><br /><br /><br /><br /><br />
                <h1>Welcome To Travle WORLD</h1>
                <br />
                <h2>Explore The World With The Travle WORLD</h2>
                <br />
                <h2>Happy Safe Travle To All</h2>
            </div>

        </div>
    );
};

export default Banner;